import { render } from "./factureInterne.vue?vue&type=template&id=e70df928&scoped=true"
import script from "./factureInterne.vue?vue&type=script&lang=js"
export * from "./factureInterne.vue?vue&type=script&lang=js"

import "./factureInterne.vue?vue&type=style&index=0&id=e70df928&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70df928"]])

export default __exports__